import useSchools from '../../hooks/useSchools';

const useExternalSchoolCheck = () => {
  const { dataQcSchool, schools } = useSchools();

  const selectedSchool = schools?.data?.find((s) => s.id === dataQcSchool);
  const isSelectedSchoolExternal = selectedSchool && selectedSchool.is_primary_on_eoa === false;

  const allSchools = schools?.data || [];
  const areAllSchoolsExternal = allSchools.length > 0 && allSchools.every((s) => s.is_primary_on_eoa === false);

  const shouldShowExternalMessage = isSelectedSchoolExternal || (!dataQcSchool && areAllSchoolsExternal);

  return shouldShowExternalMessage;
};

export default useExternalSchoolCheck;
